import { useRef } from "react";
import { motion, useScroll, useTransform } from "framer-motion";
import { MANIFESTO, IMAGES, ABOUT } from "../data";

const Chapter = ({ c, i }) => (
  <motion.div
    initial={{ opacity: 0, y: 60 }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, margin: "-100px" }}
    transition={{ duration: 0.9, ease: [0.16, 1, 0.3, 1] }}
    data-testid={`manifesto-${i}`}
    className="grid grid-cols-1 items-start gap-6 border-t border-white/10 py-12 md:grid-cols-[0.4fr_1fr] md:gap-16 md:py-16"
  >
    <span className="font-display text-6xl font-700 outline-text md:text-8xl">{c.n}</span>
    <div>
      <h3 className="font-accent text-3xl font-600 uppercase tracking-wide chrome-text-soft md:text-5xl">
        {c.title}
      </h3>
      <p className="mt-5 max-w-xl font-body text-base leading-relaxed text-neutral-400">{c.copy}</p>
    </div>
  </motion.div>
);

export const Manifesto = () => {
  const ref = useRef(null);
  const { scrollYProgress } = useScroll({ target: ref, offset: ["start end", "end start"] });
  const y = useTransform(scrollYProgress, [0, 1], ["-12%", "12%"]);

  return (
    <section id="legend" ref={ref} data-testid="manifesto" className="relative overflow-hidden carbon px-5 py-28 md:px-10 md:py-40">
      {/* parallax image accent */}
      <motion.div style={{ y }} className="pointer-events-none absolute right-0 top-1/2 -z-0 hidden w-[42%] -translate-y-1/2 opacity-20 lg:block">
        <div className="clip-frame overflow-hidden">
          <img src={IMAGES.manifesto} alt="engine detail" className="h-[70vh] w-full object-cover" />
        </div>
      </motion.div>
      <div className="absolute inset-0 -z-0 bg-gradient-to-r from-black via-black/70 to-transparent" />

      <div className="relative z-10 mx-auto max-w-[1400px]">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.8 }}
          className="mb-8 max-w-2xl"
        >
          <span className="font-accent text-xs uppercase tracking-[0.4em] text-[#ffb000]">Why FTC Owns the Road</span>
          <h2 className="mt-4 font-display text-4xl font-700 uppercase leading-[0.95] chrome-text md:text-6xl">
            The Legend
          </h2>
          <p className="mt-6 font-body text-base leading-relaxed text-neutral-400">{ABOUT}</p>
        </motion.div>

        <div className="max-w-4xl">
          {MANIFESTO.map((c, i) => (
            <Chapter key={c.n} c={c} i={i} />
          ))}
          <div className="border-t border-white/10" />
        </div>
      </div>
    </section>
  );
};
